/* eslint-disable */
import React from "react";
import userManager from "../../../../Utils/Oidc/userManager";
import M_RedirectToLogin from "../../Molecules/Common/Navigations/M_RedirectToLogin";
import M_UnsupportedBrowser from "../../Molecules/Common/error/M_UnsupportedBrowser";
import ErrorBoundary from "../../Molecules/Common/error/ErrorBoundary";
import { isUnsupportedBrowser } from "../../../../Utils/Helpers/common";
class LoginPage extends React.Component {
  state = { isUnsupported: isUnsupportedBrowser() };
  componentDidMount() {
    let pathname =
      this.props.history &&
      this.props.history.location.state &&
      this.props.history.location.state.referrer &&
      this.props.history.location.state.referrer.pathname
        ? this.props.history.location.state.referrer.pathname
        : "";
    if (!this.state.isUnsupported) {
      userManager.signinRedirect({ data: { pathname: pathname } });
    }
  }

  render() {
    console.log("isUnsupported: ", this.state.isUnsupported);
    if (this.state.isUnsupported) {
      return (
        <div style={styles.root}>
          <M_UnsupportedBrowser />
        </div>
      );
    }
    return (
      <div style={styles.root}>
        <ErrorBoundary>
          <M_RedirectToLogin />
        </ErrorBoundary>
      </div>
    );
  }
}

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    // backgroundImage: "linear-gradient(#1C3D35,#234)",
    backgroundColor: "#0b0e0e",
    backgroundImage: `radial-gradient(circle at 0% 100%, rgba(84, 172, 180, 0.6) 0%, transparent 50%), radial-gradient(circle at 100% 100%, rgba(68, 133, 87, 0.6) 0%, transparent 50%)`,
    height: "100vh",
    //backgroundColor: "#000",
  },
};

export default LoginPage;
